import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TemplateStore, for use in the registry */ export const TemplateStoreActionTypes = [
    ActionType.FetchBuiltinTemplateDataSucceeded,
    ActionType.FetchBuiltinTemplateData,
    ActionType.FetchBuiltinTemplateDataFailed
];
